<div class="side-sheet-form">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">
      <ng-content select="[sidesheet-title]"></ng-content>
    </h5>
    <button
      type="button"
      class="btn-close text-reset"
      aria-label="Close"
      (click)="onDismiss()"
    ></button>
  </div>
  <nav #nav="ngbNav" [ngClass]="{ 'nav-hidden': !showNav() }" class="offcanvas-nav nav-tabs" ngbNav>
    @for (content of contents; track content.label; let index = $index) {
      <ng-container
        [ngbNavItem]="index"
        [destroyOnHide]="true"
        [disabled]="content.disabled || (index > 0 && !contents.get(index - 1)?.currentStepValid())"
      >
        <button ngbNavLink [class.active]="index <= nav.activeId">
          {{ content.label | translate }}
        </button>
        <ng-template ngbNavContent>
          <ng-container [ngTemplateOutlet]="content.template"></ng-container>
        </ng-template>
      </ng-container>
    }
  </nav>
  <div class="offcanvas-body" [ngbNavOutlet]="nav"></div>

  <div class="offcanvas-footer">
    @if (showBackButton && nav.activeId !== 0) {
      <button im-button class="inverted" (click)="nav.select(nav.activeId - 1)">
        {{ 'general.back_a' | translate }}
      </button>
    }

    @if (showNextOrDoneButton) {
      @if (nav.activeId !== contents?.length - 1) {
        <button
          im-button
          class="primary ms-auto"
          [disabled]="loading || !contents.get(nav.activeId)?.currentStepValid()"
          (click)="onNext()"
        >
          @if (loading) {
            <rs-web-loader></rs-web-loader>
          } @else {
            {{ 'next' | translate }}
          }
        </button>
      } @else {
        <button
          im-button
          class="primary ms-auto"
          [disabled]="loading || !contents.get(nav.activeId)?.currentStepValid()"
          (click)="onDone()"
        >
          @if (loading) {
            <rs-web-loader></rs-web-loader>
          } @else {
            {{ contents.get(nav.activeId).customDoneButtonText || doneButtonText | translate }}
          }
        </button>
      }
    }
  </div>
</div>
